module.exports = __webpack_public_path__ + "static/media/1014873.dedcc20d.jpg";